// export const apiUrl = 'http://localhost:8000/api';
// export const domainUrl = 'http://localhost:8000';

export const apiUrl = 'https://trainingauditworkflow.corientbiz.com/api';
export const domainUrl = 'https://trainingauditworkflow.corientbiz.com';

// export const apiUrl = 'https://auditworkflow.corientbiz.com/api';
// export const domainUrl = 'https://auditworkflow.corientbiz.com';
